import { createBaseContext } from '../core/state.js';
import { query, queryAll } from '../core/dom.js';

export function buildSelectorsContext() {
  const ctx = createBaseContext();

  ctx.menuToggle = query('[data-menu-toggle]');
  ctx.menuPanel = query('[data-menu-panel]');
  ctx.menuClose = query('[data-menu-close]');
  ctx.menuLinks = ctx.menuPanel ? queryAll('a', ctx.menuPanel) : [];
  ctx.menuProductLinks = ctx.menuPanel ? queryAll('[data-product-link]', ctx.menuPanel) : [];
  ctx.menuPanelImage = ctx.menuPanel ? query('.menu-panel__image-inner', ctx.menuPanel) : null;
  ctx.header = query('.site-header');
  ctx.heroTitleLines = queryAll('.hero__title-line');
  ctx.heroSubtitle = query('.hero__subtitle');
  ctx.heroProducts = queryAll('.hero__product-card');

  ctx.detailSection = query('.home-detail');
  ctx.detailSegments = ctx.detailSection ? queryAll('.home-detail__segment', ctx.detailSection) : [];
  ctx.detailTitle = ctx.detailSection ? query('.home-detail__title', ctx.detailSection) : null;
  ctx.detailDescription = ctx.detailSection ? query('.home-detail__description', ctx.detailSection) : null;

  ctx.ecommerceSection = query('.home-ecommerce');
  ctx.ecommerceText = ctx.ecommerceSection ? query('.home-ecommerce__text', ctx.ecommerceSection) : null;
  ctx.ecommerceMedia = ctx.ecommerceSection ? query('.home-ecommerce__media', ctx.ecommerceSection) : null;
  ctx.ecommerceCTA = ctx.ecommerceSection ? query('.home-ecommerce__cta', ctx.ecommerceSection) : null;
  ctx.ecommerceProgressTrack = ctx.ecommerceSection
    ? query('.home-ecommerce__progress-track', ctx.ecommerceSection)
    : null;
  ctx.ecommerceSlidesWrapper = ctx.ecommerceSection
    ? query('[data-ecommerce-slides]', ctx.ecommerceSection)
    : null;
  ctx.ecommerceSlides = ctx.ecommerceSection
    ? queryAll('[data-ecommerce-slide]', ctx.ecommerceSection)
    : [];
  ctx.ecommerceProgressCurrent = ctx.ecommerceSection
    ? query('[data-ecommerce-progress-current]', ctx.ecommerceSection)
    : null;
  ctx.ecommerceProgressTotal = ctx.ecommerceSection
    ? query('[data-ecommerce-progress-total]', ctx.ecommerceSection)
    : null;

  ctx.blogSliderSection = query('.home-blog__slider');
  ctx.blogSliderTitle = ctx.blogSliderSection
    ? query('.home-blog__slider-title', ctx.blogSliderSection)
    : null;
  ctx.blogSliderNav = ctx.blogSliderSection ? query('.home-blog__nav', ctx.blogSliderSection) : null;
  ctx.blogSliderTrack = ctx.blogSliderSection
    ? query('[data-home-blog-slider-track]', ctx.blogSliderSection)
    : null;

  ctx.ecoSliderSection = query('[data-home-eco-slider]');
  ctx.ecoSliderTrack = ctx.ecoSliderSection
    ? query('[data-home-eco-slider-track]', ctx.ecoSliderSection)
    : null;
  ctx.ecoSliderControls = ctx.ecoSliderSection
    ? query('.home-eco-slider__controls', ctx.ecoSliderSection)
    : null;

  ctx.historySection = query('.history');
  ctx.historyTitle = ctx.historySection ? query('.history__title', ctx.historySection) : null;
  ctx.historyDescription = ctx.historySection
    ? query('.history__description', ctx.historySection)
    : null;
  ctx.historyCTA = ctx.historySection ? query('.history__button', ctx.historySection) : null;
  ctx.historyAsideText = ctx.historySection
    ? query('.history__aside-text', ctx.historySection)
    : null;

  ctx.blogInner = query('.home-blog__inner');

  return ctx;
}
